import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill='#202020'
        d='M20 17.222H6.667a.889.889 0 000 1.778H20v1.778H6.667A2.667 2.667 0 014 18.11V4.778A1.778 1.778 0 015.778 3H20v14.222zM5.778 15.49c.144-.03.292-.045.444-.045h12V4.778H5.778v10.71zm9.778-6.267H8.444V7.444h7.112v1.778z'
      ></path>
    </svg>
  )
}

export default Icon
